import { Middleware } from "@reduxjs/toolkit";
import posthog from "posthog-js";
import { posthogApiKey } from "@/config/posthog";
import { setUser, logout } from "./auth-slice";

export const posthogMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);

  if (!posthogApiKey) return result;

  if (setUser.match(action) && action.payload) {
    const { email, _id, userRole, tenantId, accessLevel, isRestricted } = action.payload;
    posthog.identify(email, {
      email,
      userId: _id,
      userRole,
      tenantId,
      accessLevel,
      isRestricted,
    });
    if (tenantId) {
      posthog.group("tenant", tenantId);
    }
  } else if (logout.match(action)) {
    posthog.capture("logout");
    posthog.reset();
  }

  return result;
};
